import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface HeaderProps {
  onMenuToggle: () => void;
}

const pageTitles: Record<string, string> = {
  '/': 'Ana Sayfa',
  '/musteriler': 'Müşteriler',
  '/servis-kayitlari': 'Servis Kayıtları',
  '/servis-planlama': 'Servis Planlama',
  '/bakim-takip': 'Bakım Takibi',
  '/mesaj-gonder': 'Mesaj İşlemleri',
  '/raporlar': 'Raporlar',
  '/personel': 'Personeller',
  '/stok': 'Stok Yönetimi',
  '/firma-ayarlari': 'Firma Ayarları',
};

export default function Header({ onMenuToggle }: HeaderProps) {
  const location = useLocation();
  const { profile } = useAuth();
  const title = pageTitles[location.pathname] || 'Sadem Panel';
  const today = new Date().toLocaleDateString('tr-TR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <header className="fixed top-0 left-0 lg:left-64 right-0 h-16 bg-white border-b border-gray-100 flex items-center justify-between px-4 md:px-6 z-20">
      <div className="flex items-center gap-4">
        <button
          onClick={onMenuToggle}
          className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-gray-100 lg:hidden cursor-pointer text-gray-600"
        >
          <i className="ri-menu-line text-xl"></i>
        </button>
        <div>
          <h1 className="text-lg font-bold text-gray-800">{title}</h1>
          <p className="text-xs text-gray-500 hidden sm:block">{today}</p>
        </div>
      </div>

      <div className="flex items-center gap-2 md:gap-3">
        <button className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-gray-100 cursor-pointer relative text-gray-600">
          <i className="ri-notification-3-line text-xl"></i>
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full"></span>
        </button>
        <div className="hidden sm:flex items-center gap-2 bg-gray-50 rounded-lg px-3 py-2">
          <div className="w-6 h-6 rounded-full bg-sky-100 flex items-center justify-center flex-shrink-0">
            <i className="ri-user-line text-sky-600 text-xs"></i>
          </div>
          <span className="text-sm font-medium text-gray-700">
            {profile ? `${profile.ad} ${profile.soyad}` : 'Yönetici'}
          </span>
        </div>
      </div>
    </header>
  );
}